import { render, staticRenderFns } from "./AccountButtons.vue?vue&type=template&id=1b08246e&"
import script from "./AccountButtons.vue?vue&type=script&lang=js&"
export * from "./AccountButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports